<template>
    <client-page>
        <div class="sub-visual sub-visual--sv2">
            <v-container>
                <h2 class="sub-visual__title"><span>RESOURCES</span></h2>
            </v-container>
        </div>

        <div class="tab-wrap mb-2 mb-lg-2">
            <v-container>
                <v-tabs :value="tab" grow show-arrows center-active class="tab tab--line">
                    <v-tab v-for="{ value, text } in tabs" :key="value" :to="`/stories/${value}`">
                        <span>{{ text }}</span>
                    </v-tab>
                </v-tabs>
            </v-container>
        </div>

        <v-tabs-items :value="tab" touchless>
            <!-- S: 회사소개 -->
            <library-list />
            <!-- E: 회사소개 -->
            <!-- S: 기사·뉴스 -->
            <customer-list />
            <!-- E: 기사·뉴스 -->
        </v-tabs-items>            
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";
import LibraryList from "@/components/client/ko/board/library/list.vue"
import CustomerList from "@/components/client/ko/board/customer/list.vue"
import { RESOURES_TABS } from "@/assets/variables";
const tabs = Object.values(RESOURES_TABS);

export default {
    components: {
        ClientPage,
        LibraryList,
        CustomerList,
    },
    props: {
        tab: { type: String, default: RESOURES_TABS.UWSSRESOURCES.value },
    },
    data() {
        return {
            tabs,
        };
    },
    mounted() {
        this.syncPath();
    },
    methods: {
        syncPath() {
            const path = `/stories/${this.tab}`;
            if (this.$route.path !== path) this.$router.replace(path);
        },
    },
};
</script>
